import React from "react";
import "./styles.module.scss";
import { IncluirVersaoApp } from "./IncluirVersaoApp";
import { GerenciarVersaoApp } from "./GerenciarVersaoApp";
import { useApp } from "../../../../context/app";

export const VersaoApp = () => {
  const { renderIncludeScreen } = useApp();
  return renderIncludeScreen ? <IncluirVersaoApp /> : <GerenciarVersaoApp />;
};
